var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('GlobalNotification',{attrs:{"type":"info","message":_vm.notificationMessage,"duration":0,"storageKey":"janekao_notice_202511"}}),_c('SiteHeader'),_c('main',{staticClass:"main-content"},[_c('div',{staticClass:"container"},[_c('router-view')],1)]),_c('SiteFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }